<!-- « Annuler » est un lien, vert sur l'encre comme la maquette. -->
<!-- Posé au-dessus de la barre du bas et de sa carotte (maquette 05) : la marge basse de la barre est d'au moins 2 rem
     (32 px, comme app-menu), la barre et la carotte font 6,25 rem. Le focus dedans arrête le délai. -->
<div role="status" aria-live="polite" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)" [style.z-index]="overSheet ? 1000000 : null" [style.bottom]="bottomOffset"
  class="fixed inset-x-4 bottom-[calc(max(var(--vw-safe-bottom),2rem)+6.25rem)] z-50 flex items-center gap-3 rounded-card bg-vw-ink py-1.5 pl-4 pr-1.5 text-vw-on-color shadow-float">
  <p class="flex flex-1 items-center gap-2.5 text-body-s font-medium">
    <vw-check-icon class="block h-5 w-5 shrink-0 text-vw-surface-tint [&>svg]:h-full [&>svg]:w-full" aria-hidden="true" />
    {{ message }}
  </p>
  <button #undoButton type="button" (click)="onUndo()"
    class="flex min-h-target shrink-0 items-center gap-1.5 rounded-pill px-3.5 text-body-s font-semibold text-vw-link-on-ink">
    <vw-rotate-ccw-icon class="h-4 w-4" aria-hidden="true"></vw-rotate-ccw-icon>
    {{ 'tasks.undo.cancel' | translate }}
  </button>
</div>
